import * as React from "react";
import LineChart from "../charts/linechart";
import { useState, useEffect } from "react";
// import { Tabs } from "antd";
import { CardBox, Highlight, ObservationBox } from "../atoms";
// import { TwitterOutlined, HeatMapOutlined } from "@ant-design/icons";
import { getJSONData } from "../utils";
import Clouds from "./clouds";
import { LightBulbIcon, CubeIcon } from "@heroicons/react/solid";
import { BadgeCheckIcon } from "@heroicons/react/outline";

// const { TabPane } = Tabs;

const ElectionTimeline = () => {
  const [eventsData, setEventsData] = useState([]);
  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    const getEvents = getJSONData(
      `${process.env.GATSBY_PATH_PREFIX}/data/events.json`
    );
    getEvents.then((data) => {
      setEventsData(data);
    });
  };

  // const eventsView = eventsData.map((data, i) => {
  //   let date = new Date(data.date);
  //   return (
  //     <div className="border p-2 rounded bg-gray-50" key={"event" + i}>
  //       <div>{date.toDateString()}</div>
  //       <div>{data.event}</div>
  //       <div>
  //         {" "}
  //         <WordCloudChart />
  //       </div>
  //     </div>
  //   );
  // });

  return (
    <div className="rounded relative ">
      <div className="my-3">
        {" "}
        This section provides an overview of frequency of data collected (all
        tweets and retweets, original tweets, and tweets labelled as political),
        and an extracted timeline of notable events.
      </div>
      <div>
        <div className="flex md:flex-row gap-2 flex-col 4">
          <div className="bg-gray-50 p-3 rounded">
            <div className="flex gap-3">
              <div className="gap-2 flex  md:flex-col">
                <CardBox
                  title="Total Tweets"
                  description="Tweets and retweets"
                  value="25.2M"
                />
                <CardBox
                  title="Total Tweets"
                  description="Original tweets"
                  value="12.6M"
                />
                <CardBox
                  title="Political Tweets"
                  description="Political tweets"
                  value="3.6M"
                />
              </div>
            </div>
          </div>
          <div className="flex-1">
            {" "}
            <LineChart />
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="text-lg font-semibold py-2">
          {" "}
          Events Timeline{" "}
          <span className="text-sm font-normal"> (wordcloud)</span>
        </div>
        <div className="py-2 mb-4">
          {" "}
          The section below illustrates a word cloud created from the content of
          tweets for "eventful" days in the dataset. Visualizing these word
          clouds provide additional context on the key topics that drove
          discussions. Click the replay button to cycle through each event.{" "}
        </div>
        <div className=" ">
          <Clouds data={eventsData} />
        </div>
      </div>

      {/* <div className="bg-white   flex-1 rounded  bg-gpray-100 ">
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <TwitterOutlined />
                Timeline in Tweets
              </span>
            }
            key="1"
          ></TabPane>
          <TabPane
            tab={
              <span>
                <HeatMapOutlined />
                Hashtag Mentions
              </span>
            }
            key="2"
          >
            <div className="flex md:flex-row gap-2 flex-col ">
              <div className="bg-gray-50 p-3 rounded">
                <div className="flex gap-2">
                  <div className="gap-2 flex  md:flex-col">
                    <CardBox
                      title="Geo tagged Tweets"
                      description="Geo tagged tweets"
                      value="8.6M"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                {" "}
                <LineChart />
              </div>
            </div>
          </TabPane>
        </Tabs> 
      </div> */}

      <div className="mt-6 rounded relative   bg-gray-50 p-3">
        <div className="grid   grid-cols-1 md:grid-cols-2 gap-4">
          <div className="  ">
            <div className="font-bold ">
              <CubeIcon className="w-4 inline-block mr-1 -mt-1 " /> Method{" "}
            </div>
            <span className="block text-xs mb-4">
              How is the data derived and analyzed?
            </span>
            <div className=" ">
              <div className="bg-gray-100 hidden rounded p-2 mb-2"> Data </div>
              <div className="mb-2">
                <span className="block mb-1  font-semibold">
                  <BadgeCheckIcon className="w-4  text-indigo-600 inline-block -mt-1 " />{" "}
                  Peak finding
                </span>
                The events identified events in the timeline are detected and
                labelled using a 3 step approach. First we apply a{" "}
                <Highlight>peak finding algorithm</Highlight> on tweet frequency
                data to identify the days with the most discussion.
              </div>
              <div className="mb-2">
                <span className="block font-semibold   mb-1">
                  <BadgeCheckIcon className="w-4 text-indigo-600 inline-block -mt-1" />{" "}
                  Qualitative Analysis
                </span>
                Next we extract tweets for that day and apply qualitative
                techniques to derive a generic title/description of the key
                events for the day. This includes computing word frequencies and
                wordclouds, inspecting a random subset of tweets (~400 tweets
                per day) and constructing search queries to verify insights.{" "}
              </div>
            </div>
            <div className=" "></div>
          </div>
          <div className=" ">
            <div className="font-bold">
              {" "}
              <LightBulbIcon className="w-4 inline-block mr-1 -mt-1 " />{" "}
              Insights{" "}
            </div>
            <span className="block text-xs mb-4">
              What are some insights on the types of events that drove
              discourse?
            </span>
            <div className=" ">
              <div className="mb-2">
                <span className="block font-semibold   mb-1">
                  <BadgeCheckIcon className="w-4 text-indigo-600 inline-block -mt-1" />{" "}
                  Most discussed event
                </span>
                The event that drew the most discussion was postponement of the
                elections exactly one week to the scheduled date.
              </div>
              <div className="mb-2">
                <span className="block font-semibold  mb-1">
                  <BadgeCheckIcon className="w-4 text-indigo-600 inline-block -mt-1" />{" "}
                  Reactions to decisions by incubent government
                </span>
                At least two spikes in the tweet frequency were related to
                decisions by the incumbent government which could impact
                election outcomes - appointment of a new elections collation
                head and the replacement of the chief justice.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElectionTimeline;
